import { useRouter } from 'next/router'

import { getUrlString } from '@/lib/utils'
import { useAuth } from '@/providers/AuthProvider'

import useFetch from './useFetch'

// `enabled` evita a requisição para usuários não autenticados
export default function useApplications(enabled = true) {
  const { isAuthenticated } = useAuth() || {}
  const router = useRouter()
  const siteSlug = getUrlString(router?.query?.site)

  return useFetch([
    siteSlug && enabled && isAuthenticated
      ? `/${siteSlug}/enrollment-store/enrollment-applications/`
      : null,
    { status: 'in_progress' }
  ])
}
